/* istanbul ignore file */
import React, { useContext } from 'react';
import { PermissionsMap } from '../utils';

export interface SecurityContext {
  permissions?: PermissionsMap;
}

const SecurityReactContext = React.createContext<SecurityContext>({});

export const SecurityProvider = SecurityReactContext.Provider;

const useSecurityReactContext = () => useContext(SecurityReactContext);

export default useSecurityReactContext;
